import { Box, Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { useNavegate } from 'App/hooks';
import { CATALOG_ROUTES } from 'domains/Catalog/catalogRoutes';
import emptyTransfers from './ProductsTransfersEmpty.png';

function ProductsTransfersEmpty() {
  const { goTo } = useNavegate();
  const { t } = useTranslation('catalog');

  return (
    <Box display="flex" flexDirection="column" gap="12" alignItems="center">
      <InitialScreen>
        <InitialScreen.Hero
          title={t('transfers.emptyState.title')}
          subtitle={t('transfers.emptyState.subtitle')}
          description={t('transfers.emptyState.description')}
          actions={
            <Button
              appearance="primary"
              onClick={() => goTo(CATALOG_ROUTES.newTransfer)}
            >
              {t('transfers.emptyState.action')}
            </Button>
          }
          image={
            <img
              src={emptyTransfers}
              alt="transfers-products-empty-state"
              width="100%"
              height="auto"
            />
          }
        />
      </InitialScreen>
    </Box>
  );
}

export default ProductsTransfersEmpty;
